"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImprintAndLegal = _interopRequireDefault(require("./components/ImprintAndLegal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  list: {
    path: "imprint",
    //icon: 'info',
    title: "Imprint - Privacy Policy - Legal",
    private: false,
    restricted: "",
    //level: 0,
    component: props => /*#__PURE__*/_react.default.createElement(_ImprintAndLegal.default, null)
  }
};
module.exports = exports.default;